import { post } from './apiUtils';

const defaultUrl = '/CompaniesDistributors/';

export default {
  saveCompanyDistributor: data => post(defaultUrl, data),
};
